import StringInput from './StringInput';

export default class URLPathInput extends StringInput {
  addValidationProblems (ev) {
    super.addValidationProblems(ev);
    if (this.urlValidationString.test(this.normalizeValue(this.value))) {
      this.addProblem(ev, 'INVALID_URL');
    }
  }

  get urlValidationString () {
    return /[^0-9a-z-]/;
  }

  get inputType () {
    return 'urlPath';
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-forms/inputs/URLPathInput.jsx